// storage to manage any persistent value at client's end
const storage = localStorage;

export const setValue = (key, value) => {
    return storage.setItem(key, value);
};

export const getValue = (key) => {
    return storage.getItem(key);
};

export default storage;
